import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import * as XLSX from 'xlsx';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fromEvent, merge, of as observableOf } from 'rxjs';
import {
  catchError,
  debounceTime,
  filter,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { ResponseSearchCustomerTable } from 'src/app/_models/search-customer';
import { SearchTableSearchCustomerService } from 'src/app/_services/search-table-search-customer.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { Lector, RequestCustomerNewOrEdit, ResponseUSer } from 'src/app/_models';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component';
import { AddBillToComponent } from '../modal/add-bill-to/add-bill-to.component';
export interface UserData {
  id: string;
  Customer: string;
  Address: string;
  Phone: string;
  Active: string;
  Activate: boolean;
}

interface active {
  value: string;
  viewValue: string;
}

/** Constants used to fill up our data base. */

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css'],
})
export class CustomersComponent implements OnInit, AfterViewInit, OnDestroy {
  IdEditar=0
  FormCustomerRequest:RequestCustomerNewOrEdit;
  viewTableCustomer = true;
  currentUser: ResponseUSer;
  mySubscription: any;
  indexTabs = new FormControl(0);
  selPayment = 'option2';
  selBilling = 'option2';
  selected = '';
  isLoadingResults = true;
  checked = true;
  checked2 = false;
  displayedColumns: string[] = ['id', 'Customer', 'Address', 'Phone', 'Active'];
  dataSource: MatTableDataSource<UserData>;
  SelectCostumerSearch = '';
  isRateLimitReached = false;
  searchTable = true;
  resultsLength = 0;

  saveCustomer = true;
  editCustomer = false;
  tab2 = false;
  IdCustomer = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TableSearchCustomerPaginator')
  TableSearchCustomerPaginator: MatPaginator;
  @ViewChild('TableSearchCustomerSort') TableSearchCustomerSort: MatSort;
  SearchDatabase: SearchTableSearchCustomerService | null;
  data: ResponseSearchCustomerTable[] = [];
  dataSourceSearch: MatTableDataSource<ResponseSearchCustomerTable>;
  placeForm: FormGroup;

  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: (toast) => {
      Swal.showLoading();
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  actives: active[] = [
    { value: '1', viewValue: 'Active' },
    { value: '0', viewValue: 'Inactive' },
  ];
  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {
    // Create 100 users

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((events) => {
        this.authenticationService.currentUser.subscribe(
          (x) => (this.currentUser = x)
        );
      });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd');
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    });

    // Assign the data to the data source for the table to render
  }
  ngOnDestroy(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';

    localStorage.setItem('header', '0');
  }

  ngOnInit(): void {
    this.placeForm = this.formBuilder.group({
      CompanyName: ['', Validators.required],
      Address: [''],
      Address1: [''],
      City: [''],
      State: [''],
      ZipCode: [''],
      Phone: [''],
      Fax: [''],
      Email: [''],
      Website: [''],
      selPayment: [''],
      selBilling: [''],
      Contactname: [''],
      Contactlastname: [''],
      ContactEmail:[""],
      ContactFax:[""],
      ContactPhone:[""],
      PayablesContactname:[""],
      PayablesContactlastname:[""],
      PayablesEmail:[""],
      PayablesFax:[""],
      PayablesPhone:[""],
      UPSAccount: [''],
      FedExAccount: [''],
      StorageFreeDays: [''],
      Activate: ['']
    });
    this.cust.StorageFreeDays.setValue(0);
    this.cust.selPayment.setValue('0');
    this.cust.selBilling.setValue('0');
  }

  get cust() {
    return this.placeForm.controls;
  }

  ngAfterViewInit(): void {
    this.OnChangeSearch(String(1));
    const main = <HTMLInputElement>document.getElementById('SubMenu');

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap((event) => {
          console.log('show');
          main.style.display = 'block';
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
        })
      )
      .subscribe((val) => {
        console.log('hide');
        main.style.display = 'none';
      });
  }
  OnChangeSearch(active: any) {
    this.viewTableCustomer = true;
    console.log('activo', active);
    this.searchTable = true;
    this.SearchDatabase = new SearchTableSearchCustomerService(this.http);
    // If the user changes the sort order, reset back to the first page.

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.OnChangeLoader();
          this.isLoadingResults = true;
          return this.SearchDatabase!.getRepoIssues(active);
        }),
        map((data) => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.length;

          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((datas) => {
        this.data = datas;
        this.dataSourceSearch = new MatTableDataSource(this.data);
        this.dataSourceSearch.sort = this.TableSearchCustomerSort;
        this.dataSourceSearch.paginator = this.TableSearchCustomerPaginator;
       
      });
  }

  callType(value) {
    console.log(value);
    this.cust.StorageFreeDays.setValue(value);
  }

  editarCust(rowcust: ResponseSearchCustomerTable) {
    console.log(rowcust)
    this.editCustomer = true;
    this.saveCustomer = false;
    
    this.IdCustomer = rowcust.id;
    this.cust.CompanyName.setValue(String(rowcust.Company_Name));
    this.cust.Address.setValue(String(rowcust.Company_Address));
    this.cust.Address1.setValue(String(rowcust.Company_Address1));
    this.cust.City.setValue(String(rowcust.Company_City));
    this.cust.State.setValue(String(rowcust.Company_State));
    this.cust.ZipCode.setValue(String(rowcust.Company_Zip));
    this.cust.Phone.setValue(String(rowcust.Company_Phone));
    this.cust.Fax.setValue(String(rowcust.Company_Fax));
    this.cust.Email.setValue(String(rowcust.Company_Email));
    this.cust.Website.setValue(rowcust.Company_Website);
    this.cust.UPSAccount.setValue(rowcust.Company_UPS_Account);
    this.cust.FedExAccount.setValue(rowcust.Company_FedEx_Account);
    this.cust.selPayment.setValue(String(rowcust.Company_PaymentTerms));
    this.cust.selBilling.setValue(String(rowcust.BillingType));
    this.cust.StorageFreeDays.setValue(rowcust.StorageFreeDays);
    this.cust.Activate.setValue(rowcust.Active);


    this.cust.Contactname.setValue(rowcust.ContactName);
    this.cust.Contactlastname.setValue(rowcust.ContactLastName);
    this.cust.ContactEmail.setValue(rowcust.ContactEmail);
    this.cust.ContactFax.setValue(rowcust.ContactFax);
    this.cust.ContactPhone.setValue(rowcust.ContactPhone);


    this.cust.PayablesContactname.setValue(rowcust.APContactName);
    this.cust.PayablesContactlastname.setValue(rowcust.APContactLastName);
    this.cust.PayablesEmail.setValue(rowcust.APContactEmail);
    this.cust.PayablesFax.setValue(rowcust.APContactFax);
    this.cust.PayablesPhone.setValue(rowcust.APContactPhone);
    this.indexTabs = new FormControl(0);

    this.tab2 = true;
  }

  OnInsertCustomer() {
    if(this.placeForm.invalid){

      return;
    }
    this.OnChangeLoader();
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
    

this.FormCustomerRequest={
  tblCompanyID:Number(this.authenticationService.currentUserValue.companyIdWh),
  company_Name:String(this.cust.CompanyName.value),
  company_Address: String(this.cust.Address.value) || ' ',
  company_Address1: String(this.cust.Address1.value) || ' ',
  company_City: String(this.cust.City.value) || ' ',
  company_State: String(this.cust.State.value)|| ' ',
  company_Zip: String(this.cust.ZipCode.value)|| ' ',
  company_Logo: ' ',
  company_Phone: String(this.cust.Phone.value)|| ' ',
  company_Fax: String(this.cust.Fax.value)|| ' ',
  company_Email: String(this.cust.Email.value)|| ' ',
  company_Website: String(this.cust.Website.value)|| ' ',
  company_UPS_Account:  String(this.cust.UPSAccount.value)|| ' ',
  company_FedEx_Account: String(this.cust.FedExAccount.value)|| ' ',
  company_PaymentTerms: String(this.cust.selPayment.value)|| '0',
  contactName: String(this.cust.Contactname.value)|| ' ',
  contactLastName: String(this.cust.Contactlastname.value)|| ' ',
  contactEmail: String(this.cust.ContactEmail.value)|| ' ',
  contactPhone: String(this.cust.ContactPhone.value)|| ' ',
  contactFax: String(this.cust.ContactFax.value)|| ' ',
  apContactName: String(this.cust.PayablesContactname.value)|| ' ',
  apContactLastName: String(this.cust.PayablesContactlastname.value)|| ' ',
  apContactEmail: String(this.cust.PayablesEmail.value)|| ' ',
  apContactPhone: String(this.cust.PayablesPhone.value)|| ' ',
  apContactFax:String(this.cust.PayablesFax.value)|| ' ',
  active: this.cust.Activate.value,
  billingType: String(this.cust.selBilling.value)|| '0',
  storageFreeDays: Number(this.cust.StorageFreeDays.value)|| 0,
  tipo: this.IdCustomer
}

    this.http
      .post<any>(
        `${environment.apiUrl}/Customer/InsertUpdateCustomer`,
        this.FormCustomerRequest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response:any) => {
        Swal.fire({
          icon: 'info',
          title: 'Customer',
          text: response.responses,
         
        })
        this.OnChangeSearch(String('1'));
        this.OnClear();
        this.indexTabs = new FormControl(1);
      });
  }

  OnUpdateCustomer() {
    this.OnChangeLoader();
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
    

this.FormCustomerRequest={
	tblCompanyID:Number(this.authenticationService.currentUserValue.companyIdWh),
	company_Name:String(this.cust.CompanyName.value),
	company_Address: String(this.cust.Address.value) || ' ',
	company_Address1: String(this.cust.Address1.value) || ' ',
	company_City: String(this.cust.City.value) || ' ',
	company_State: String(this.cust.State.value)|| ' ',
	company_Zip: String(this.cust.ZipCode.value)|| ' ',
	company_Logo: ' ',
	company_Phone: String(this.cust.Phone.value)|| ' ',
	company_Fax: String(this.cust.Fax.value)|| ' ',
	company_Email: String(this.cust.Email.value)|| ' ',
	company_Website: String(this.cust.Website.value)|| ' ',
	company_UPS_Account:  String(this.cust.UPSAccount.value)|| ' ',
	company_FedEx_Account: String(this.cust.FedExAccount.value)|| ' ',
	company_PaymentTerms: String(this.cust.selPayment.value)|| '0',
	contactName: String(this.cust.Contactname.value)|| ' ',
	contactLastName: String(this.cust.Contactlastname.value)|| ' ',
	contactEmail: String(this.cust.ContactEmail.value)|| ' ',
	contactPhone: String(this.cust.ContactPhone.value)|| ' ',
	contactFax: String(this.cust.ContactFax.value)|| ' ',
	apContactName: String(this.cust.PayablesContactname.value)|| ' ',
	apContactLastName: String(this.cust.PayablesContactlastname.value)|| ' ',
	apContactEmail: String(this.cust.PayablesEmail.value)|| ' ',
	apContactPhone: String(this.cust.PayablesPhone.value)|| ' ',
	apContactFax:String(this.cust.PayablesFax.value)|| ' ',
	active: this.cust.Activate.value,
	billingType: String(this.cust.selBilling.value)|| '0',
	storageFreeDays: Number(this.cust.StorageFreeDays.value)|| 0,
	tipo: this.IdCustomer
  }

    this.http
      .post<any>(
        `${environment.apiUrl}/Customer/InsertUpdateCustomer`,
        this.FormCustomerRequest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe(() => {
        this.OnClear();
        this.OnChangeSearch(String(this.cust.Activate.value));
        this.indexTabs = new FormControl(1);
      });
  }
  applyFilter(filterValue: String) {
    this.dataSourceSearch.filter = filterValue.trim().toLowerCase();
  }
  OnClear() {
	this.placeForm.reset();
    this.IdCustomer = 0;
	if (this.editCustomer) {
		console.log('entro')
		this.indexTabs = new FormControl(0);
		this.indexTabs = new FormControl(1);


    this.tab2 = false;
	}else{
		console.log('entroelse')

		this.indexTabs = new FormControl(0);

    this.tab2 = false;
	}
	this.saveCustomer=true;
	this.editCustomer=false;
  }
  OnChangeLoader() {
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 2000);
  }
  @ViewChild('exportExcel') table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx');
  }
  datosLector: Lector;

  openDialogLector(): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.dataSourceSearch.filter = result.Resultado.trim().toLowerCase();

      if (this.dataSourceSearch.paginator) {
        this.dataSourceSearch.paginator.firstPage();
      }
    });
  }
  openDialogPayorAdd(customerId:any): void {
    const dialogRef = this.dialog.open(AddBillToComponent, {
      width: '30vw',
      height:'20vh',
      data: Number(customerId)
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
 
    });
  }
}
